import uuidv4 from "uuid/v4";

export default {

  data() {

    return {

      indicatorTypes: [
        {
          value: 1,
          label: "Виджет на панели",
          iconClass: "fa fa-share-alt fa-fw",
          disabled: false
        },
        {
          value: 2,
          label: "Сообщение на e-mail",
          iconClass: "fa fa-envelope-o fa-fw",
          disabled: true
        },
        {
          value: 3,
          label: "SMS сообщение",
          iconClass: "fa fa-mobile fa-fw",
          disabled: true
        },
      ],

      recipientTypes: [
        {
          value: 1,
          label: "Стартер"
        },
        {
          value: 2,
          label: "Исполнитель"
        }
      ],

    }
  },

  methods: {

    /**
     *
     *
     * @param type
     * @returns {*}
     */
    getIndicatorIconClassByType: function (type = 1) {

      let index = this.indicatorTypes.findIndex(_type => Boolean(_type.value = type));

      if (index < 0) {
        index = 0;
      }

      return this.indicatorTypes[index].iconClass
    },

    /**
     *
     *
     * @param type
     * @returns {string}
     */
    getParameterLabelByType: function(type) {

      let label = '';

      switch (String(type)) {

        case "1":
          label = 'Текст (строка)';
          break;

        case "2":
          label = 'Текстовый блок';
          break;

        case "3":
          label = 'Электронная почта';
          break;

        case "4":
          label = 'Дата';
          break;

        case "5":
          label = 'Да/Нет';
          break;

        case "6":
          label = 'Переключатель';
          break;

        case "7":
          label = 'Выпадающий список';
          break;

        case "8":
          label = 'Выпадающий список (API)';
          break;

        case "9":
          label = 'Файл';
          break;

        case "10":
          label = 'Переключатель (API)';
          break;

        default:
          label = '';
          break;
      }

      return label;
    },

    /**
     *
     *
     * @param processObject
     * @param id
     * @returns {*}
     */
    getProcessNameByPortId: function (processObject, id) {

      let portObject = processObject.findPort(id);
      let portProcessID = portObject.getProcessID();

      // console.log("portProcessID for port #" + port_id + " = " + portProcessID);

      let portProcess = (portProcessID == processObject.getID())
        ? processObject
        : processObject.getProcess(portProcessID);

      // console.log("portProcess for port #" + port_id);
      // console.log(portProcess);

      return this.getNameValue(portProcess);
    },

    /**
     *
     *
     * @param processObject
     * @param id
     * @returns {*}
     */
    getPortNameById: function (processObject, id) {

      let portObject = processObject.findPort(id);

      return this.getNameValue(portObject);
    },

    /**
     *
     *
     * @param processObject
     * @param id
     * @returns {*}
     */
    getIndicatorNameByStateId: function (processObject, id) {

      if (id) {

        let stateObject = processObject.getIndicatorState(id);

        if (stateObject) {

          let indicatorObject = processObject.getIndicator( stateObject.getIndicatorID() );

          return this.getNameValue(indicatorObject);
        }
      }

      return "Indicator Name for state #" + id;
    },

    /**
     *
     *
     * @param processObject
     * @param id
     * @returns {*}
     */
    getStateNameById: function (processObject, id) {

      let stateObject = processObject.getIndicatorState(id);

      if (stateObject) {
        return this.getNameValue(stateObject);
      }

      return "State Name for state #" + id;
    },

    /**
     *
     *
     * @param obj
     * @returns {string}
     */
    getNameValue: function (obj) {
      return obj.getName() + (this.$bpmDebug.forms ? ' (#' + obj.getID() + ')' : '');
    },

    /**
     * Добавление нового элемента в список.
     *
     */
    addListItem: function () {

      this.formDataCurrent.options.list.push({
          key: uuidv4(),
          value: ''
      });
    },

    /**
     * Удаление элемента из списка.
     *
     * @param index Индекс элемента
     */
    removeListItem: function (index) {
        this.formDataCurrent.options.list.splice(index, 1);
    }
  }
}



// WEBPACK FOOTER //
// ./src/apps/bpm/designer/mixins/designer.js